import { useEffect, useRef, useState } from "react";
import { getData } from "../../utils/apiCalls";
import { svgs } from "../../assets/svgs";
import { tracking } from "../../utils/tracking";
import { useLocation } from "react-router-dom";


export const Hotel = () => {
   const [isOpen, setIsOpen] = useState(0)
   const [data, setData] = useState([])
   const hotelsRef = useRef(null)
   const location = useLocation()

   useEffect(() => {
      getData(`https://youngstartup.io/api/cwebsite/get_hotels`)
         .then(res => {
            setData(res)
         })
   }, []);

   useEffect(() => {
      if (location.hash.split('?')[0] === '#hotels' && data.length > 0) {
         hotelsRef.current.scrollIntoView({ behavior: 'smooth'})
      }
   }, [data]);


   if (data.length === 0) return <></>

   return (
      <div className='hotel'>
         <div ref={hotelsRef} style={{scrollMargin:'100px'}}></div>
         <h1>Discounted Hotel Rooms</h1>
         <h3>Check back soon for more and make sure to book now as rooms will sell out fast!</h3>
         <div className="card-container">
            {
               data.map((hotel, idx) =>
                  <div className="hotel-card" key={idx} >
                     <img onClick={() => setIsOpen(hotel.id)} src={hotel.thumbnail} alt="" />
                     <div className="star">
                        {Array(hotel.rating).fill().map((i, idx) =>
                           <span key={idx}>{svgs.star}</span>)}
                     </div>
                     <h3>{hotel.name}</h3>
                     <h4>{hotel.price_text}</h4>
                     <div className="btn-container">
                        <a className="btn b2" onClick={() => tracking(354, hotel.id)} href={hotel.link} target="_blank" >Book Now</a>
                     </div>
                     {isOpen === hotel.id && <div className="modal-container">
                        <div className="hotel-modal">
                           <img src={hotel.image_1} alt="" />
                           <h1>{hotel.name}</h1>
                           <h3>{hotel.address}</h3>
                           <h3>{hotel.distance}</h3>
                           <h4>{hotel.price_text}</h4>
                           <div className="star">
                              {Array(hotel.rating).fill().map((i, idx) =>
                                 <span key={idx}>{svgs.star}</span>)}
                           </div>
                           <a className="btn b2" onClick={() => tracking(353, hotel.id)} href={hotel.link} target="_blank" >Book Now</a>
                           <p>{hotel.description}</p>
                           <button onClick={() => { setIsOpen(0) }}>Close</button>
                        </div>
                     </div>}
                  </div>
               )
            }
         </div>
      </div>
   )
}
